// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"328":"admin","535":"login","799":"institution","835":"audit-logs"}[chunkId] || chunkId) + "." + {"174":"2e9847b1","328":"c987d85a","535":"73f57037","604":"b7a0aa8b","626":"ae50d583","799":"1627373d","835":"d40684f4","985":"582a2dc1"}[chunkId] + ".css";
};